const APP_NAME = process.env.REACT_APP_NAME
const APP_VERSION = process.env.REACT_APP_VERSION
const API_URL = process.env.REACT_APP_API_URL
const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL
const OHIF_URL = process.env.REACT_APP_OHIF_URL

const NODE_ENV = process.env.NODE_ENV

const CUSTOMER_DISPLAY_CHANNEL = 'customer-display'

const KTP_SCANNER_IP = process.env.REACT_APP_KTP_SCANNER_IP
const KTP_SCANNER_SCAN_SERVICE_PORT = process.env.REACT_APP_KTP_SCANNER_SCAN_SERVICE_PORT
const KTP_SCANNER_FILE_TRANSFER_SERVICE_PORT = process.env.REACT_APP_KTP_SCANNER_FILE_TRANSFER_SERVICE_PORT
const KTP_SCANNER_SECURE_PROTOCOL = process.env.REACT_APP_KTP_SCANNER_SECURE_PROTOCOL === 'true'
const KTP_SCANNER_DEVICE_ID = process.env.REACT_APP_KTP_SCANNER_DEVICE_ID

const PRINTER_SERVER_SECURE = process.env.REACT_APP_PRINTER_SERVER_SECURE === 'true'

const POOLING_INTEVAL_MS = 2000

const PAGINATION_LIMIT = 10

export {
  APP_NAME,
  APP_VERSION,
  API_URL,
  NODE_ENV,
  CUSTOMER_DISPLAY_CHANNEL,
  POOLING_INTEVAL_MS,
  WEBSITE_URL,
  KTP_SCANNER_IP,
  KTP_SCANNER_FILE_TRANSFER_SERVICE_PORT,
  KTP_SCANNER_SCAN_SERVICE_PORT,
  KTP_SCANNER_SECURE_PROTOCOL,
  KTP_SCANNER_DEVICE_ID,
  PRINTER_SERVER_SECURE,
  PAGINATION_LIMIT,
  OHIF_URL,
}
